// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeString = (value: any): string => value ?? '';
